import React, { Component } from 'react'
import Translation from '../General/Translation'
import Directors from '../MovieInformation/Directors'
import MovieLength from '../MoviesGeneral/MovieLength'
import FskWrapper from '../MovieInformation/FskWrapper'

class SliderBasicInformation extends Component {
    render() {
        const { fsk, directors, translation, length } = this.props
        if(!directors && !length) 
        return ''
        
        else 

        return (
        <div className={'information'}>
            <div className='fsk-length-wrapper'>
                <FskWrapper fsk={fsk} />
                {(length || length !== 0) && <MovieLength length={length} translation={translation}/>}
            </div>
            {directors && <div className='actor-director-info'><Directors directors={directors} actors={[]} translation={translation}/></div>}
        </div>
        )
    }
}  

export default SliderBasicInformation